<template>
  <div class="wrap">
    <div class="newswrap">
      <div class="part1">

        <Head />
        <p class="p1">{{$t('m_newslist.tit')}}</p>
        <p class="p2">NEWS</p>
      </div>
      <div class="list">
        <router-link
          tag="div"
          class="item"
          v-for="(item,index) in list"
          :key="index"
          :to="'/mobile/newsdetail/'+item.id"
        >
          <div class="left">
            <div class="image">
              <img
                :src="(item.pic==''||item.pic==null)?imgYs:item.pic"
                alt
              />
            </div>
          </div>
          <div class="right">
            <p class="p1">{{item.description}}</p>
            <p class="p2">{{$t('m_newslist.time')}}{{item.createdTime}}</p>
          </div>
        </router-link>

        <div
          v-if="showMore"
          class="btn"
          @click="loadMore"
        >
          <p>
            <span>查看更多</span>
            <i class="iconfont  iconxia"></i>
          </p>
          <!-- <Button type="primary" @click="loadMore" :loading="loadingMore" ghost>加载更多</Button> -->
          
        </div>
        <!-- <div
          v-if="!showMore"
          class="isshowall"
        >{{$t('m_newslist.nomore')}}</div> -->
      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import api from "../../common/api";
import { Button } from "iview";
export default {
  data() {
    return {
      rows: 5,
      page: 1,
      list: [],
      showMore: false,
      loadingMore: false,
      lang: localStorage.getItem("Lang"),
      imgYs:require('../../assets/images/mobile/newslist/defaultpic.png')
    };
  },
  components: {
    Head,
    Foot,
    Button,
  },
  watch: {},
  created() {
    this.getnewslist();
  },
  methods: {
    getnewslist() {
      this.$axios
        .get(api.getReportList, {
          params: {
            rows: this.rows,
            page: this.page,
            lang: this.lang,
          },
        })
        .then((res) => {
          let data = res.data;
          data.list.forEach((ele) => {
            this.list.push({
              id: ele.id,
              title: ele.title,
              month: ele.createdTime.substring(0, 7),
              day: ele.createdTime.substring(8, 10),
              description: ele.description,
              createdTime: ele.createdTime.substring(0, 10).replace(/-/g, "/"),
              pic: ele.picSmall,
            });
          });
          this.showMore = this.rows * this.page < data.total ? true : false;
          this.loadingMore = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadMore() {
      this.page++;
      this.loadingMore = true;
      this.getnewslist();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.newswrap {
  min-height: calc(100vh - 19.3333vw);
}

.part1 {
  height: vw(650);
  width: vw(750);
  overflow: hidden;
  margin-top: vw(98);
  background: url('../../assets/images/mobile/newslist/bg.png') no-repeat center;
  background-size: 100% 100%;

  .p1 {
    font-size: vw(40);
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: vw(40);
    margin: vw(60) 0 vw(9);
  }

  .p2 {
    margin-left: vw(361);
    font-size: vw(60);
    color: #fff;
    opacity: 0.12;
    line-height: vw(60);
  }
}

.list {
  padding: vw(60) vw(30) vw(80);

  .item {
    box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);
    height: vw(237);
    width: 100%;
    display: flex;
    padding: vw(44) vw(30) 0;
    margin-bottom: vw(30);

    .left {
      width: vw(210);
      height: vw(212);
      margin-right: vw(30);

      .image {
        width: vw(200);
        height: vw(150);

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .right {
      flex: 1;

      .p1 {
        font-size: vw(28);
        color: #444444;
        line-height: vw(36);
        margin-bottom: vw(14);
        pline(3);
      }

      .p2 {
        padding-top: vw(20);
        font-size: vw(24);
        border-top: vw(2) dashed rgba(229, 229, 229, 1);
        color: #888888;
        line-height: vw(24);
      }
    }
  }

  .isshowall {
    font-size: vw(18);
    font-weight: 400;
    color: rgba(194, 194, 194, 1);
    line-height: 1.2;
    margin: vw(35) 0 vw(70);
    text-align: center;
  }

   .btn {
    margin-top: vw(50);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }
}
</style>
